"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DNSRecordType = void 0;
var DNSRecordType;
(function (DNSRecordType) {
    DNSRecordType["A"] = "A";
    DNSRecordType["AAAA"] = "AAAA";
    DNSRecordType["CNAME"] = "CNAME";
    DNSRecordType["MX"] = "MX";
    DNSRecordType["NS"] = "NS";
    DNSRecordType["SOA"] = "SOA";
    DNSRecordType["SRV"] = "SRV";
})(DNSRecordType || (exports.DNSRecordType = DNSRecordType = {}));
//# sourceMappingURL=dns-record.js.map